export enum WalkingPerim {
  ONE = 'One',
  FIVE = 'Five',
}

export const walkingPerimMapping = {
  [WalkingPerim.ONE]: $localize`:@@common_walkingPerim_one:One`,
  [WalkingPerim.FIVE]: $localize`:@@common_walkingPerim_five:Five`,
};
